const SUB_PAGE_NAMES = {
	MARKET: 'marketdata',
	ON_CHAIN: 'onchain',
};

export default SUB_PAGE_NAMES;
